import { IconButton } from '../../IconButton/index.js'
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import { REDO_COMMAND } from 'lexical'

export const Redo = ({ disabled, size }) => {
  const [editor] = useLexicalComposerContext()

  return (
    <IconButton
      tooltip="Redo"
      keyHint="Cmd+Shift+Z"
      keyHintVisualOnly
      size={size}
      icon="curved-arrow-right"
      disabled={disabled}
      onClick={() => {
        editor.dispatchCommand(REDO_COMMAND, undefined)
      }}
    />
  )
}
